require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-agi-suretrack-pro.json") })
        }
      }, "path---projects-agi-suretrack-pro");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-agi-suretrack-pro!./.cache/json/projects-agi-suretrack-pro.json
// module id = 509
// module chunks = 231608221292675